<div
  class="form-control__wrapper"
  data-test-id="officeHoursFormControlWrapper"
  [ngClass]="{
    'form-control__wrapper--inline': direction === 'row',
    'form-control__wrapper--flat': direction === 'filter',
  }"
>
  <label
    class="form-control__label"
    data-test-id="officeHoursFormControlLabelWrapper"
  >
    <p class="t-data t-bold" data-test-id="officeHoursFormControlLabel">
      {{ config.label }}
    </p>
  </label>

  <div
    class="office-hours__group-controls"
    data-test-id="officeHoursFormControlGroupWrapper"
    [ngClass]="{ 'u-fillRemaining': direction === 'row' }"
  >
    @for (
      checkboxConfig of officeHourConfigs;
      track checkboxConfig;
      let i = $index
    ) {
      <form-control
        direction="filter"
        [config]="checkboxConfig"
        [group]="daysOfWeekGroup"
        [control]="daysOfWeekGroup.controls[checkboxConfig.prop]"
        [attr.data-test-id]="'officeHoursDaysOfWeekFormControl_' + i"
      >
      </form-control>
      @if (currentDaysVal[checkboxConfig.prop]) {
        <div class="office-hours__time-picker">
          <form-control
            [group]="group"
            [config]="timeConfig"
            direction="filter"
            [control]="
              group.controls[config.prop].controls[checkboxConfig.prop].controls
                .from
            "
            [attr.data-test-id]="'officeHoursFromTimeFormControl_' + i"
          >
          </form-control>
          <p class="t-data" [attr.data-test-id]="'officeHoursToText_' + i">
            to
          </p>
          <form-control
            [group]="group"
            [config]="timeConfig"
            direction="filter"
            [control]="
              group.controls[config.prop].controls[checkboxConfig.prop].controls
                .to
            "
            [attr.data-test-id]="'officeHoursToTimeFormControl_' + i"
          >
          </form-control>
        </div>
      }
    }
  </div>
</div>
